import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../auth";
import { useLang } from "../lang";
import { LOGO_MAIN } from "../content";
import AdminRequests from "../components/portal/AdminRequests";
import DatasheetLibrary from "../components/portal/DatasheetLibrary";
import AdminProfessionals from "../components/portal/AdminProfessionals";

export default function Portal() {
  const { user, loading, logout, authAxios } = useAuth();
  const { lang, t } = useLang();
  const navigate = useNavigate();
  const isAdmin = user?.role === "admin";

  useEffect(() => { if (!loading && !user) navigate("/login"); }, [user, loading, navigate]);

  if (loading || !user) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-[#6e6e73] text-sm">Loading…</div>
      </div>
    );
  }

  return (
    <main className="min-h-screen bg-[#f5f5f7] pb-24" data-testid="portal-page">
      <div className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[#d2d2d7]">
        <div className="max-w-[1200px] mx-auto px-6 h-12 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_MAIN} alt="HGW" className="h-5" />
            <span className="hidden md:inline text-[12px] text-[#6e6e73]">/ {t.portal}</span>
          </Link>
          <div className="flex items-center gap-4 text-[12px] text-[#6e6e73]">
            <span className="hidden md:inline">{user.company || user.email}</span>
            <button
              onClick={async () => { await logout(); navigate("/"); }}
              data-testid="portal-logout"
              className="text-[#1D3F94] hover:underline"
            >{lang === "it" ? "Esci" : "Sign out"}</button>
          </div>
        </div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 pt-10">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="mb-10">
          <h1 className="text-[32px] md:text-[44px] font-semibold tracking-[-0.02em] text-[#1d1d1f]">
            {lang === "it" ? `Ciao, ${user.name.split(" ")[0]}.` : `Hello, ${user.name.split(" ")[0]}.`}
          </h1>
          <p className="mt-2 text-[15px] md:text-[17px] text-[#6e6e73]">
            {lang === "it"
              ? "Benvenuto nell'Area riservata: qui trovi tutte le schede tecniche dei sistemi."
              : "Welcome to the reserved area: here you'll find all system datasheets."}
          </p>
        </motion.div>

        {isAdmin && <AdminRequests lang={lang} authAxios={authAxios} />}
        {isAdmin && <AdminProfessionals lang={lang} authAxios={authAxios} />}

        <DatasheetLibrary />
      </div>
    </main>
  );
}
